import React from 'react';
import { Button } from 'antd';
import './styles.css';

interface TopRightPanelProps {
  onSave?: () => void;
  onShowOPL?: () => void;
  onExport?: () => void;
  onImport?: () => void;
  isSaving?: boolean;
}

const TopRightPanel: React.FC<TopRightPanelProps> = ({
  onSave,
  onShowOPL,
  onExport,
  onImport,
  isSaving = false,
}) => {
  return (
    <div className="top-right-panel">
      {/* 导入导出按钮 */}
      <div className="import-export-buttons">
        <button className="import-export-button" onClick={onImport} title="导入JSON">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 12V14H13V12H14V14C14 14.5523 13.5523 15 13 15H3C2.44772 15 2 14.5523 2 14V12H3ZM8.53033 10.4697L11.75 7.25L10.5 6L8 8.5V1H7V8.5L4.5 6L3.25 7.25L6.46967 10.4697L7.5 11.5L8.53033 10.4697Z" fill="#697077"/>
          </svg>
        </button>
        <button className="import-export-button" onClick={onExport} title="导出JSON">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 1V3H2V1C2 0.447715 2.44772 0 3 0H13C13.5523 0 14 0.447715 14 1V3H13V1H3ZM7.5 11.5L6.46967 10.4697L3.25 7.25L4.5 6L7 8.5V1H8V8.5L10.5 6L11.75 7.25L8.53033 10.4697L7.5 11.5Z" fill="#697077"/>
          </svg>
        </button>
      </div>

      {/* 保存按钮 */}
      {onSave && (
        <Button
          type="primary"
          onClick={onSave}
          loading={isSaving}
          className="save-button"
        >
          {isSaving ? '保存中...' : '保存'}
        </Button>
      )}

      {/* 查看OPL语言按钮 */}
      <button className="opl-button" onClick={onShowOPL} title="本体定义语言">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M9 1.125C11.8995 1.12502 14.25 3.47552 14.25 6.375C14.25 6.54169 14.2408 6.70643 14.2256 6.86914C16.0124 7.70673 17.25 9.52117 17.25 11.625C17.25 14.5245 14.8995 16.875 12 16.875C10.8843 16.875 9.8505 16.526 9 15.9326C8.1495 16.526 7.11572 16.875 6 16.875C3.10051 16.875 0.75 14.5245 0.75 11.625C0.75 9.52149 1.9871 7.7069 3.77344 6.86914C3.75825 6.70645 3.75 6.54166 3.75 6.375C3.75 3.4755 6.10051 1.125 9 1.125ZM4.1416 8.36719C3.01159 9.01319 2.25 10.2301 2.25 11.625C2.25 13.6961 3.92893 15.375 6 15.375C6.68344 15.375 7.32321 15.1905 7.875 14.8711C7.17097 13.9777 6.75 12.8507 6.75 11.625C6.75 11.458 6.75819 11.2929 6.77344 11.1299C5.58616 10.573 4.64157 9.58516 4.1416 8.36719ZM13.8564 8.36719C13.3563 9.58511 12.413 10.5731 11.2256 11.1299C11.2408 11.2929 11.25 11.458 11.25 11.625C11.25 12.851 10.8283 13.9776 10.124 14.8711C10.676 15.1908 11.3163 15.375 12 15.375C14.0711 15.375 15.75 13.6961 15.75 11.625C15.75 10.2295 14.9873 9.01297 13.8564 8.36719ZM9.74805 11.5703C9.50364 11.6052 9.25405 11.625 9 11.625C8.74563 11.625 8.49568 11.6053 8.25098 11.5703C8.25072 11.5885 8.25 11.6067 8.25 11.625C8.25 12.4693 8.52917 13.2482 9 13.875C9.47083 13.2482 9.75 12.4693 9.75 11.625C9.75 11.6067 9.74831 11.5885 9.74805 11.5703ZM9 9.37402C8.83197 9.59761 8.68946 9.84119 8.57422 10.0996C8.714 10.1154 8.85599 10.125 9 10.125C9.14369 10.125 9.28532 10.1153 9.4248 10.0996C9.30959 9.84132 9.16795 9.59751 9 9.37402ZM6 7.875C5.85601 7.875 5.71398 7.88362 5.57422 7.89941C5.89989 8.63017 6.45167 9.23731 7.1416 9.63184C7.32779 9.17847 7.576 8.75725 7.875 8.37793C7.3233 8.05867 6.68326 7.875 6 7.875ZM12 7.875C11.3164 7.875 10.6759 8.05841 10.124 8.37793C10.4231 8.75727 10.6712 9.17841 10.8574 9.63184C11.5476 9.23738 12.099 8.63026 12.4248 7.89941C12.2854 7.88369 12.1437 7.875 12 7.875ZM9 2.625C6.92893 2.625 5.25 4.30393 5.25 6.375C5.25 6.39294 5.25073 6.41083 5.25098 6.42871C5.49565 6.39376 5.74566 6.375 6 6.375C7.11552 6.375 8.14959 6.72317 9 7.31641C9.85041 6.72317 10.8845 6.375 12 6.375C12.254 6.375 12.5037 6.39385 12.748 6.42871C12.7483 6.41083 12.75 6.39294 12.75 6.375C12.75 4.30395 11.071 2.62502 9 2.625Z"
            fill="#697077"
          />
        </svg>
      </button>
    </div>
  );
};

export default TopRightPanel;